import PiPopupWindowPreview from "../previews/components/PiPopupWindowPreview";
import PiPopupHeaderBar from "../previews/components/PiPopupHeaderBar";
import { InteractionType } from "../../models/interactions/Interaction";
import SequencePreviewBody from "./SequencePreviewBody";

export default function SequencePreview() {
  // todo maximize window

  return (
    <PiPopupWindowPreview
      header={<PiPopupHeaderBar interactionType={InteractionType.Sequence} title="Sequence" />}
      body={<SequencePreviewBody />}
      size="full"
    />
  );
}
